<template>
  <div class="about_us">
    <div class="about_top">
      <div class="logo_view">
        <img src="../assets/logo.png" alt="logo" style="width: 41px;height: 41px">
        <img src="../assets/logo1.png" alt="logo" style="width: 144px;height: 22px">
        <span>Fulfillment</span>
      </div>
      <a-tabs v-model="activeKey"
              @change="callback"
              :tabBarStyle="{ borderBottom: 'unset' }">
        <a-tab-pane
          v-for="item in types"
          :key="item.key"
          :tab="item.name">
        </a-tab-pane>
      </a-tabs>
      <div class="login_btn">
        <img src="../assets/login.png" style="width: 30px;height: 30px"/>
        <span @click="goLogin()">Login</span>
      </div>
    </div>
    <header class="header">
      <a-icon type="arrow-left" @click="goBack()" v-if="false"
              style="position: absolute;left: 10px;top: 10px;font-size: 25px;color: #FFFFFF"/>
      <div class="title">About Printbelle Fulfillment</div>
      <div class="list">
        <div class="item" v-for="(item,i) in list" :key="i">
          <img :src="item.icon" :style="{width:item.width,height:item.height}"/>
          <span class="content">{{ item.content }}</span>
          <span class="count">{{ item.count }}</span>
        </div>
      </div>
    </header>
    <content class="content">
      <div class="content_1">
        <span class="title">Printbelle in Numbers</span>
        <div class="list">
          <div class="item" v-for="(item,i) in list1" :key="i">
            <span class="count">{{ item.count }}</span>
            <span class="content">{{ item.content }}</span>
          </div>
        </div>
      </div>
      <div class="content_2">
        <span class="title">Why Printbelle </span>
        <span class="des">E-Commerce is all Commerce. Demand has never been higher for delivery, neither have the stakes. It's time to expand your roster of trusted delivery partners. We're here to earn your trust.</span>
        <div class="list">
          <div class="item" v-for="(item,i) in list2" :key="i">
            <img :src="item.icon" :style="{width:item.width,height:item.height}"/>
          </div>
        </div>
      </div>
    </content>
    <footer class="footer_box">
      <div class="track_view">
        <img @click="goToTrack()" class="img" src="../assets/track.png"/>
      </div>
      <div class="footer">
        <div class="footer_view">
          <img src="../assets/logo1.png" style="width: 228px;height: 35px"/>
          <span class="title" style="margin-bottom: 18px;">CUSTOMER SERVICE</span>
          <span class="content" style="margin-bottom: 25px;">
          DIKE INTERNATIONAL CO., LIMITED <br> ROOM 1002 10/F EASEY <br> COMMERCIAL BUILDING 253-261 <br>  HENNESSY ROAD WANCHAI HK
        </span>
          <span class="content" style="margin-bottom: 25px;">
          PRINTBELLE FULLMENT
        </span>
          <span class="content">Email: Logistic@printbelle.com</span>
        </div>
        <div class="footer_view">
          <span class="title">PRODUCTS</span>
          <a class="content" @click="goToLink(1)">Clothing</a>
          <a class="content" @click="goToLink(2)">Home & Living</a>
          <a class="content" @click="goToLink(3)">Accessories</a>
          <a class="content" @click="goToLink(4)">Outdoor</a>
          <a class="content" @click="goToLink(5)">Shoes</a>
          <a class="content" @click="goToLink(6)">Automotive</a>
        </div>
        <div class="footer_view">
          <span class="title">ABOUT US</span>
          <a class="content" @click="goToLink(7)">About Us</a>
          <a class="content" @click="goToLink(8)">FAQ list</a>
        </div>
        <div class="footer_view">
          <span class="title">TERMS AND POLICY</span>
          <a class="content" @click="goToLink(9)">Customs & Duties</a>
        </div>
      </div>
      <div class="foot_line"></div>
    </footer>

  </div>

</template>

<script>
export default {
  name: 'AboutUs',
  data () {
    return {
      activeKey: -1,
      types: [
        {
          key: 0,
          name: 'Tracking',
        },
      ],
      list: [
        {
          icon: require('@/assets/about1.png'),
          content: 'Items fulfilled each month',
          count: '1,000,000+',
          width: 88,
          height: 90
        },
        {
          icon: require('@/assets/about2.png'),
          content: 'Products to customize',
          count: '500+',
          width: 87,
          height: 87
        },
        {
          icon: require('@/assets/about3.png'),
          content: 'Average time Performance',
          count: '5-7d',
          width: 97,
          height: 89
        },
        {
          icon: require('@/assets/about4.png'),
          content: 'Oversea Logistic Partner',
          count: '30+',
          width: 120,
          height: 87
        },
      ],
      list1: [
        {
          count: '1,700',
          content: 'Employees Globally',
        },
        {
          count: '10,000',
          content: 'Clients Globally',
        },
        {
          count: '700,000',
          content: 'Dalily Global Parcel Deliveries',
        },
      ],
      list2: [
        {
          icon: require('@/assets/about5.png'),
          width: 90,
          height: 104
        }, {
          icon: require('@/assets/about6.png'),
          width: 80,
          height: 81
        }, {
          icon: require('@/assets/about7.png'),
          width: 153,
          height: 72
        }, {
          icon: require('@/assets/about8.png'),
          width: 160,
          height: 49
        }, {
          icon: require('@/assets/about9.png'),
          width: 80,
          height: 81
        }, {
          icon: require('@/assets/about10.png'),
          width: 107,
          height: 96
        },
      ]
    }
  },
  methods: {
    goBack () {
      this.$router.push({name: 'ParcelTracking'})
    },
    callback () {
      this.$router.push({name: 'Index'})
    },
    goToLink (type) {
      let link = 'https://www.printbelle.com/collections/clothing'
      switch (type) {
        case 1:
          link = 'https://www.printbelle.com/collections/clothing'
          break
        case 2:
          link = 'https://www.printbelle.com/collections/home--living'
          break
        case 3:
          link = 'https://www.printbelle.com/collections/accessories'
          break
        case 4:
          link = 'https://www.printbelle.com/collections/outdoor'
          break
        case 5:
          link = 'https://www.printbelle.com/collections/shoes'
          break
        case 6:
          link = 'https://www.printbelle.com/collections/automotive'
          break
        case 7:
          link = 'https://www.printbelle.com/pages/about-us-1'
          break
        case 8:
          link = 'https://www.printbelle.com/pages/faq-list'
          break
        case 9:
          link = 'https://www.printbelle.com/pages/customs--duties'
          break
      }
      window.open(link, '_blank')
    },
    goLogin () {
      window.open('https://www.printbelle.com/', '_blank')
    },
    goToTrack () {
      window.open('https://www.17track.net/?utm_medium=logistics&utm_source=PB速递', '_blank')
    },
  }
}
</script>

<style lang="less">

.about_us {
  display: flex;
  flex-direction: column;

  .about_top {
    display: flex;
    align-items: center;
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    justify-content: space-between;
    height: 70px;
    width: 100%;
    min-width: 1900px;
    padding: 0 47px;
    background-color: #152235;

    .logo_view {
      width: 395px;
      display: flex;
      height: 70px;
      align-items: center;

      img {
        margin-right: 18px;
      }

      span {
        font-size: 17px;
        font-family: OPPOSans;
        font-weight: bold;
        color: #C9C8C8;
        margin-left: 50px;
      }
    }

    .login_btn {
      width: 395px;
      display: flex;
      cursor: pointer;
      align-items: center;
      justify-content: right;
      height: 70px;

      span {
        height: 20px;
        font-size: 18px;
        line-height: 20px;
        font-weight: bold;
        margin-left: 10px;
        color: #C9C8C8;
      }
    }

    .ant-tabs-ink-bar {
      background-color: transparent;
    }

    .ant-tabs-bar {
      margin: 0;
    }

    .ant-tabs-tab {
      color: #FFFFFF;
      font-size: 18px;
      font-weight: bold;
    }

    .ant-tabs-tab-active {
      color: #FFB400;
    }

    .ant-tabs-tab:hover {
      color: #FFB400;
    }
  }

  .header {
    background-image: url(../assets/about_bg.jpg);
    background-size: 100% 100%;
    height: 788px;
    margin-top: 70px;
    position: relative;

    .title {
      font-size: 60px;
      line-height: 44px;
      height: 44px;
      font-family: FONTSPRING DEMO - Proxima Nova;
      font-weight: bold;
      margin-top: 129px;
      color: #FFFFFF;
    }

    .list {
      display: flex;
      margin-top: 80px;
      justify-content: center;

      .item {
        width: 330px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content {
          width: 211px;
          line-height: 32px;
          font-size: 26px;
          margin-top: 36px;
          font-family: FONTSPRING DEMO - Proxima Nova;
          font-weight: bold;
          color: #FFFFFF;
        }

        .count {
          font-size: 75px;
          font-family: Accidental Presidency;
          font-weight: 500;
          letter-spacing: -3px;
          color: #FFFFFF;
        }
      }

    }
  }

  .content {

    .title {
      font-size: 60px;
      line-height: 44px;
      height: 44px;
      font-family: FONTSPRING DEMO - Proxima Nova;
      font-weight: bold;
      color: #171717;
    }

    .content_1 {
      width: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      height: 506px;
      background: #F8F8F8;


      .list {
        display: flex;
        justify-content: center;
        margin-top: 70px;

        .item {
          width: 379px;
          height: 199px;
          background: #FFFFFF;
          justify-content: center;
          display: flex;
          margin: 0 15px;
          flex-direction: column;
          align-items: center;
          border-bottom: 3px solid #FFB400;
          box-shadow: 0 0 14px 0 rgba(74, 74, 74, 0.25);

          .count {
            height: 63px;
            line-height: 63px;
            font-size: 75px;
            font-family: Accidental Presidency;
            font-weight: 400;
            letter-spacing: -3px;
            color: #761FEB;
          }

          .content {
            width: 248px;
            height: 24px;
            line-height: 28px;
            font-size: 24px;
            margin-top: 18px;
            font-family: FONTSPRING DEMO - Proxima Nova;
            font-weight: bold;
            color: #626262;
          }
        }
      }
    }

    .content_2 {
      width: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      height: 500px;
      background: #FFFFFF;

      .des {
        width: 946px;
        height: 51px;
        font-size: 20px;
        margin-top: 36px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #626262;
        line-height: 30px;
      }

      .list {
        display: flex;
        justify-content: center;
        margin-top: 70px;

        .item {
          width: 200px;
          background: #FFFFFF;
          justify-content: center;
          display: flex;
          margin: 0 15px;
          flex-direction: column;
          align-items: center;
        }
      }
    }
  }

  .footer_box {
    background: #152235;
    padding: 120px 20px 90px 80px;
    position: relative;

    .track_view {
      width: 800px;
      position: absolute;
      display: flex;
      align-items: flex-start;
      right: 203px;
      bottom: 140px;

      .img {
        width: 107px;
        height: 32px;
        cursor: pointer;
        z-index: 1;
        margin-left: 32px;
      }
    }

    .foot_line {
      width: 1550px;
      height: 1px;
      margin-top: 36px;
      margin-left: 70px;
      border: 1px solid #FFFFFF;
      opacity: 0.3;
    }
  }

  .footer {
    display: flex;
    justify-content: space-around;
    position: relative;

    .footer_view {
      width: 300px;
      display: flex;
      flex-direction: column;

      img {
        width: 228px;
        height: 35px;
        margin-top: 3px;
        margin-bottom: 38px;
      }

      .title {
        font-size: 19px;
        text-align: left;
        margin-bottom: 30px;
        font-family: FONTSPRING DEMO - Proxima Nova;
        font-weight: 400;
        color: #FFFFFF;
      }

      .content {
        font-size: 16px;
        text-align: left;
        line-height: 28px;
        margin-top: 15px;
        margin-bottom: 10px;
        font-weight: 300;
        color: #FFFFFF;
      }

      a:hover {
        text-decoration: underline;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/AboutUs.vue